import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { PasswordStrength } from "@/components/PasswordStrength";

const EMPTY = { current: "", new: "", confirm: "" };

export const ChangePasswordButton = () => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const close = () => { setOpen(false); setF(EMPTY); setError(""); };
  const save = async (e) => {
    e.preventDefault(); setError("");
    if (f.new.length < 8) return setError("La nuova password deve avere almeno 8 caratteri");
    if (f.new !== f.confirm) return setError("Le due password non coincidono");
    setBusy(true);
    try { await api.post("/auth/change-password", { current: f.current, new: f.new }); toast.success("Password aggiornata"); close(); }
    catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  const field = (k, label, ac) => (
    <label className="block text-xs text-slate-500">{label}
      <Input type="password" autoComplete={ac} className="mt-1" data-testid={`change-password-${k}-input`} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} />
      {k === "new" && <PasswordStrength value={f.new} />}
    </label>
  );
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="change-password-button" className="mt-2 flex items-center gap-2 text-sm text-slate-600 transition-colors hover:text-blue-600">
        <KeyRound className="h-4 w-4" /> Cambia password
      </button>
      <Dialog open={open} onOpenChange={(o) => !o && close()}>
        <DialogContent className="w-[calc(100%-2rem)] max-w-md rounded-2xl bg-white" data-testid="change-password-dialog">
          <DialogHeader><DialogTitle>Cambia password</DialogTitle></DialogHeader>
          <form onSubmit={save} className="space-y-3">
            {field("current", "Password attuale", "current-password")}
            {field("new", "Nuova password (min 8 caratteri)", "new-password")}
            {field("confirm", "Ripeti nuova password", "new-password")}
            {error && <div data-testid="change-password-error" className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700">{error}</div>}
            <DialogFooter><Button type="button" variant="ghost" onClick={close}>Annulla</Button>
              <Button type="submit" disabled={busy} data-testid="change-password-save-button" className="bg-blue-600 hover:bg-blue-700">{busy ? "Salvataggio..." : "Salva password"}</Button></DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
